import React from 'react'
import { Card, CardContent, CardHeader } from '@/shared/ui'
import InstallInstructionsContent from './InstallInstructionsContent'

export default function InstallInstructionsCard() {
  return (
    <Card id="install-instructions">
      <CardHeader className="text-sm font-medium">Como instalar</CardHeader>
      <CardContent className="space-y-4">
        <InstallInstructionsContent />
      </CardContent>
    </Card>
  )
}
